(function (_) {
    'use strict';

    _['NOTIFICATIONS_TITLE'] = 'Notifications';
    _['NOTIFICATIONS.POPUP.TITLE'] = 'Unread notifications';
    _['NOTIFICATIONS.POPUP.MSG'] = 'You have unread notifications on your notification center.';
    _['NOTIFICATIONS.POPUP.BTN'] = 'See notifications';
    _['NOTIFICATIONS.NO-NOTIFICATIONS'] = 'There are no notifications yet.';
    _['NOTIFICATIONS.NO-PERMISSION'] = 'Push notifications are disabled for this app.';

}(translations['en']));



// WEBPACK FOOTER //
// ./src/app/modules/notifications/lang/notifications-lang_en.js